<!--
 * @Author: Junjie
 * @Date: 2023-02-20 14:35:10
 * @LastEditTime: 2023-02-20 14:35:48
 * @email: 781433561@qq.com
 * @Description: 时序数据类快速时间下拉
 * @FilePath: /iplus-iwt-fe/src/components/jeecg/JTsdbTimeRange.vue
-->
<template>
  <a-select @change="timeChange" style="width:100%" v-model="selectValue">
    <a-select-option :key="key" :value="time.value" v-for="(time,key) in timeRangeOption">{{ time.text }}</a-select-option>
  </a-select>
</template>

<script>

  export default {
    name: 'TsdbTimeRange',
    props: {
      value: {
        type: [String, Array],
        required: true
      },

      keys: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: 'Text'
      },
    },
    data () {
      return {
        selectValue: '',
        timeRangeOption: [
          {
            value: 'noValue',
            from: 'now',
            to: 'now',
            text: '请选择'
          },
          {
            value: 'Last 1 hour',
            from: 'now-1h',
            to: 'now',
            text: '最近1小时'
          },
          {
            value: 'Last 3 hours',
            from: 'now-3h',
            to: 'now',
            text: '最近3小时'
          },
          { value: 'Last 6 hours', from: 'now-6h', to: 'now', text: '最近6小时' },
          {
            value: 'Last 12 hours',
            from: 'now-12h',
            to: 'now',
            text: '最近12小时'
          },
          {
            value: 'Last 24 hours',
            from: 'now-24h',
            to: 'now',
            text: '最近24小时'
          },
          { value: 'Last 2 days', from: 'now-2d', to: 'now', text: '最近2天' },
          { value: 'Last 7 days', from: 'now-7d', to: 'now', text: '最近7天' },
          { value: 'Last 30 days', from: 'now-30d', to: 'now', text: '最近30天' },
          { value: 'Last 90 days', from: 'now-90d', to: 'now', text: '最近90天' },
          { value: 'Last 6 months', from: 'now-6M', to: 'now', text: '最近6个月' },
          { value: 'Last 1 year', from: 'now-1y', to: 'now', text: '最近1年' },
          //   { value: 'Last 2 years', from: 'now-2y', to: 'now', text: '最近2年' },
          //   { value: 'Last 5 years', from: 'now-5y', to: 'now', text: '最近5年' },
          { value: 'Yesterday', from: 'now-1d/d', to: 'now-1d/d', text: '昨天' },
          {
            value: 'Day before yesterday',
            from: 'now-2d/d',
            to: 'now-2d/d',
            text: '前天'
          },
          {
            value: 'This day last week',
            from: 'now-7d/d',
            to: 'now-7d/d',
            text: '上周的这一天'
          },
          {
            value: 'Previous week',
            from: 'now-1w/w',
            to: 'now-1w/w',
            text: '上周'
          },
          {
            value: 'Previous month',
            from: 'now-1M/M',
            to: 'now-1M/M',
            text: '上个月'
          },
          {
            value: 'Previous year',
            from: 'now-1y/y',
            to: 'now-1y/y',
            text: '前一年'
          },
          { value: 'Today', from: 'now/d', to: 'now/d', text: '今天' },
          { value: 'Today so far', from: 'now/d', to: 'now', text: '今天截至目前' },
          { value: 'This week', from: 'now/w', to: 'now/w', text: '这周' },
          {
            value: 'This week so far',
            from: 'now/w',
            to: 'now',
            text: '本周截至目前'
          },
          { value: 'This month', from: 'now/M', to: 'now/M', text: '本月' },
          {
            value: 'This month so far',
            from: 'now/M',
            to: 'now',
            text: '本月截至目前'
          },
          { value: 'This year', from: 'now/y', to: 'now/y', text: '今年' },
          {
            value: 'This year so far',
            from: 'now/y',
            to: 'now',
            text: '今年截至目前'
          }

        ],
        parseTime: null
      }
    },
    created () {

    },
    methods: {
      timeChange (v) {
        this.parseTimeFn(v)
        this.$emit('change', this.parseTime)
      },
      parseTimeFn (v) {
        const { from, to } = this.timeRangeOption.find(item => item.value === v)
        this.parseTime = [from, to]
      }
    },
    watch: {
      value: {
        handler: function (newValue, oldValue) {
          if (newValue && oldValue === undefined) {

            const timeIsArray = Object.prototype.toString.call(newValue) === '[object Array]'
            const parseTime = timeIsArray ? newValue[2] : newValue

            this.parseTimeFn(parseTime)
            this.selectValue = parseTime
          }
        },
        immediate: true
      },
      selectValue: {
        handler: function (newValue, oldValue) {
          if (newValue !== oldValue) {
            this.$emit('input', this.parseTime)
          }
        },
        immediate: true
      }
    }
  }
</script>
